import { api } from '../../app/services/api';
import { ScanResponse, Uship } from './types';

export const ushipApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUship: builder.query<ScanResponse, string>({
      query(orderNumber: string) {
        return {
          url: `uship/${orderNumber}`,
        };
      },
      providesTags: (result, err, orderNumber) => [
        { type: 'uship', id: `uship-${orderNumber}` },
      ],
    }),

    createUship: builder.mutation<Uship, { formData: FormData }>({
      query({ formData }: { formData: FormData }) {
        console.log('createUship mutation triggered.');
        console.log('Request Datas:', formData);

        const orderNumber = formData.get('order_number');
        console.log({ orderNumber });
        const overrides = {
          order_number: formData.get('order_number') || '',
          service_type: formData.get('service_type') || '',
          address_line: formData.getAll('address_line') || [],
          city: formData.get('city') || '',
          state: formData.get('state') || '',
          postal_code: formData.get('postal_code') || '', // changed from PostalCode
          country_code: formData.get('country_code') || '',
          phone_number: formData.get('phone_number') || '', // changed from PhoneNumber
          number_of_fedex_boxes:
            parseInt(formData.get('number_of_fedex_boxes') as string) || 0,
        };
        console.log({ overrides });
        console.log({ formData });
        return {
          url: `uship/${orderNumber}`,
          method: 'POST',
          // headers: {
          //   'Content-Type': 'application/json',
          // },
          data: overrides,
        };
      },
      invalidatesTags: (result, err, { formData }) => {
        const orderNumber = formData.get('order_number');
        return [{ type: 'uship', id: `uship-${orderNumber}` }];
      },
    }),

    cancelUship: builder.mutation<void, string>({
      query(orderNumber: string) {
        return {
          url: `uship/${orderNumber}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (orderNumber) => [
        { type: 'uship', id: `uship-${orderNumber}` },
      ],
    }),

    // Force-build the aggregated UShipment for an incomplete bundle.
    // Returns the UShipment that the operator is now ready to ship.
    forceShipBundle: builder.mutation<Uship, string>({
      query(barcode: string) {
        return {
          url: `uship/${barcode}?force=true`,
          method: 'GET',
        };
      },
      invalidatesTags: (result, err, barcode) => [
        { type: 'uship', id: `uship-${barcode}` },
      ],
    }),
  }),
});

export const {
  useGetUshipQuery,
  useCreateUshipMutation,
  useCancelUshipMutation,
  useForceShipBundleMutation,
} = ushipApi;
